export default __webpack_public_path__ + "static/7-2--8e7b5d945f6b990815e02152bb136ff9.png";